import { Paper, withStyles } from '@material-ui/core';

export const Default = Paper;

export const Stretch = withStyles({
  root: {
    flex: 1,
  },
})(Paper);
